<template>
  <div class="wt-processing-asset">
    <div class="wt-asset-container">
      <wt-progress-native :value="100" :max="100" />
      <div class="-label">
        Processing
        <wt-ellipsis-animation />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    asset: { type: Object, required: true },
    isNarration: { type: Boolean, default: false },
  },

  beforeDestroy() {
    if (this.$_cpTrackProcessing) {
      this.$_cpTrackProcessing.cancel();
    }
  },

  created() {
    // if not in local UploadQueue - > listen to firebase
    const model = app.UploadQueue.unfinished.find((model) => {
      return model.get('metadata').assetUUID === this.asset.metadata.assetUUID;
    });

    if (!model) {
      this.$_cpTrackProcessing = app.UploadQueue.trackProcessingFinish(
        this.asset.metadata.assetUUID,
        this.isNarration
      );

      this.$_cpTrackProcessing.then(
        (res) => {
          this.$_cpTrackProcessing = null;
          app.Vue.$$set(this.asset, res);
          this.asset.metadata.uploadStatus = app.uploadStatus.DONE;
        },
        (/* res*/) => {
          this.asset.metadata.uploadStatus = app.uploadStatus.FAILED;
        }
      );
    }
  },
};
</script>
